import { render, staticRenderFns } from "./ObjectImages.vue?vue&type=template&id=aadc8efe"
import script from "./ObjectImages.vue?vue&type=script&lang=js"
export * from "./ObjectImages.vue?vue&type=script&lang=js"
import style0 from "./ObjectImages.vue?vue&type=style&index=0&id=aadc8efe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports